<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                :disabled="isResult"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                :disabled="isResult"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="equips.length == 0"
    >
      {{ $t('Nenhum equipamento encontrado') }}
    </v-alert>

    <div v-else>
      <v-row class="ma-0" justify="center">
        <v-col cols="12" lg="8">
          <strong>Total: {{ total }}</strong>

          <div>
            <PieChart
              :chartData="chartData"
              :options="options"
              :key="chartKey"
            />
          </div>

          <div>
            <v-data-table
              :loading="loading"
              :loading-text="$t('Carregando...')"
              :no-data-text="$t('Nenhum setor encontrado')"
              :headers="equipsHeader"
              :items="equips"
              class="main-table"
              dense
              hide-default-header
              :hide-default-footer="!filterProp.data"
              :header-props="headerProps"
              :items-per-page="7"
              :mobile-breakpoint="0"
            >
              <template #header="{ props, on }">
                <thead>
                  <tr>
                    <th
                      class="text-center"
                      v-for="header in props.headers"
                      :key="header.value"
                    >
                      <v-simple-checkbox
                        v-if="header.value === 'data-table-select'"
                        v-model="props.everyItem"
                        :indeterminate="props.someItems && !props.everyItem"
                        color="purple"
                        @input="on['toggle-select-all']"
                      ></v-simple-checkbox>

                      <div>
                        <v-hover v-slot="{ hover }">
                          <div>
                            <span>{{ $t(header.text) }}</span>
                            <v-icon
                              v-if="
                                hover &&
                                header.value != 'data-table-select' &&
                                header.value != 'actions'
                              "
                              color="white"
                              class="mx-2"
                              @click="on.sort(header.value)"
                            >
                              {{
                                props.options.sortBy.includes(header.value)
                                  ? `mdi-chevron-down`
                                  : `mdi-chevron-up`
                              }}
                            </v-icon>
                          </div>
                        </v-hover>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>

              <template #[`item.department`]="{ item }">
                {{ item.name }}
              </template>

              <template #[`item.quantity`]="{ item }">
                {{ item.equipment.length }}
              </template>

              <template #[`item.park`]="{ item }">
                {{
                  total
                    ? ((item.equipment.length / total) * 100).toFixed(2)
                    : '0'
                }}%
              </template>
            </v-data-table>
            <div class="pagination" v-if="!filterProp.data">
              <div class="item-pagination block-two">
                <v-pagination
                  class="pagination-item"
                  v-model="filter.page"
                  :length="totalPages"
                  :total-visible="3"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../../../services/ApiService'
import PieChart from '../../../../charts/barChart'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  components: {
    PieChart,
    TiptapVuetify,
  },

  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    review: String,
    isResult: { type: Boolean, default: false },
  },

  async created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data: () => ({
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
    opt: {
      is3D: true,
    },
    totalPages: 1,
    loading: false,
    departmentNames: [],
    equipmentQuantity: [],
    equips: [],
    chartData: {},
    filter: {
      page: 1,
      pageSize: 14,
      institutionId: null,
      unidadeIds: [],
      startDate: null,
      endDate: null,
      review: '',
    },
    startDate: null,
    endDate: null,
    options: {},
    backgroundColors: [
      '#426483',
      '#BBCF20',
      '#0F3565',
      '#212950',
      '#C4E8F2',
      '#ED8990',
      '#FDB578',
      '#7EE882',
    ],
    equipsHeader: [
      {
        text: 'Setor',
        align: 'left',
        value: 'department',
      },
      {
        text: 'Quantidade',
        align: 'center',
        value: 'quantity',
      },
      {
        text: '% parque',
        align: 'left',
        value: 'park',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    total: 0,
    chartKey: false,
  }),

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: '1.1 - Equipamentos por setor',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    fillEquipmentDepartment() {
      this.chartData = {
        labels: this.departmentNames,
        datasets: [
          {
            label: this.$t('Equipamentos'),
            backgroundColor: this.backgroundColors,
            data: this.equipmentQuantity,
            fill: false,
            pointStyle: 'square',
          },
        ],
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },

    fillOptions() {
      this.options = {
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: true,
          labels: {
            usePointStyle: true,
          },
        },
      }
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.total
        this.totalPages = response.content.pager.totalPages
        this.equips = response.content.objects

        this.departmentNames = []
        this.equipmentQuantity = []

        this.getBackgroundColors(response.content.chartsModel.length)

        this.haveResponse = response.content.chartsModel.length

        if (this.haveResponse) {
          response.content.chartsModel.map((chart) => {
            this.departmentNames.push(chart.name)
            this.equipmentQuantity.push(chart.quantity)
          })
        }

        this.fillEquipmentDepartment()
        this.fillOptions()
        return
      }

      this.setDates()
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/equipmentByDepartment', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.totalPages = response.content.pager.totalPages
          this.equips = response.content.objects

          this.departmentNames = []
          this.equipmentQuantity = []

          this.getBackgroundColors(response.content.chartsModel.length)

          this.haveResponse = response.content.chartsModel.length

          if (this.haveResponse) {
            response.content.chartsModel.map((chart) => {
              this.departmentNames.push(chart.name)
              this.equipmentQuantity.push(chart.quantity)
            })
          }
        })

      this.fillEquipmentDepartment()
      this.fillOptions()
    },

    getBackgroundColors(length) {
      this.backgroundColors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        this.backgroundColors.push(
          `#${Math.floor(Math.random() * 16777215).toString(16)}`
        )
      }
    },
  },
  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>

<style></style>
